export default "__VITE_ASSET__BZU$Oduc__"